<script>
  import ToggleButton from './component/ToggleButton.svelte';

  export let elementId;
  export let elementShadow;
</script>

<ToggleButton {elementId} {elementShadow} label="Search availability" />
